module.exports = __webpack_public_path__ + "static/img/page2.b46317c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/page2.jpg
// module id = BVK6
// module chunks = 0